import Button from "../button/Button";
import InputBox from "../inputBox/InputBox";

export default function RegisterBox({
  bgButton,
  setInputValue,
  inputValue,
  placeholder,
  btnTitle,
  nextPage,
  title,
  otp = false,
  minutes,
  seconds,
  errorMessage,
  err,
  handleClick,
  maxLength,
}) {
  return (
    <div className="w-full bg-scabCard rounded-[20px] px-5 py-6 flex flex-col">
      <span className="w-full text-xlarge font-IRANSansBold text-scabBlack">
        ورود | ثبت نام
      </span>
      <span className="w-full font-IRANSans text-medium mt-3 mb-5 text-scabBlack leading-7">
        {title}
      </span>

      {otp ? (
        <div
          className={`w-full h-[48px] flex rounded-[12px] overflow-hidden border ${
            err ? "border-scabBlack" : "border-scabRed"
          }`}
        >
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            className={`flex-1 h-full text-center bg-scabLightGray2 text-large font-IRANSansBold outline-none tracking-[6px] ${
              err ? "text-scabBlack" : "text-scabRed"
            }`}
            placeholder={placeholder}
            onChange={(e) =>
              setInputValue(e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            value={inputValue}
          />
          <div className="w-[88px] h-full bg-scabDarkYellow flex items-center justify-center font-IRANSansBold text-large text-scabBlack shrink-0">
            {minutes}:{seconds}
          </div>
        </div>
      ) : (
        <InputBox
          placeholder={placeholder}
          setInputValue={setInputValue}
          inputValue={inputValue}
          err={err}
          maxLength={maxLength}
        />
      )}

      <div
        className={`w-full justify-center text-scabRed text-small my-2 ${
          err ? "hidden" : "flex"
        }`}
      >
        {errorMessage !== "" ? errorMessage : ""}
      </div>

      <div className="w-full mt-5">
        <Button
          title={btnTitle}
          bgButton={bgButton}
          nextPage={nextPage}
          heightCode={false}
          handleClick={handleClick}
        />
      </div>
    </div>
  );
}
